import type { ReactNode } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { UnlockBadge } from "app/components/React/QuickSearch/UnlockBadge/UnlockBadge";

type RecentItemTitleProps = {
    pageTitle: string;
    isLocked: boolean;
    dataAutomation?: string;
};

export const RecentItemTitle = ({ pageTitle, isLocked, dataAutomation }: RecentItemTitleProps): ReactNode => {
    const { translate } = useTranslate();

    return (
        <Flex
            gap="8px"
            alignItems="center"
        >
            <Text
                fontVariant="subtitle1"
                color={colorsPalettes.carbon[500]}
                data-automation={dataAutomation}
            >
                {translate(pageTitle)}
            </Text>
            {isLocked ? <UnlockBadge /> : null}
        </Flex>
    );
};
